import API from "libs/api";
import { createBaseInstance } from "libs/request";
// @ts-ignore
import config from "config/index";

class TenantAPI extends API {
  constructor(props?) {
    super(props);

    this.instance = this.createInstance(
      `${config.api.mts}Me/Tenants`,
      createBaseInstance
    );
  }

  getById = (id) => this.instance.get(`/${id}`);
}

export default TenantAPI;
